var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.btnClass,attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.executeJob()}}},[(_vm.loading)?_c('frm-spinner'):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }